function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaqs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.5,
    height: 20.5,
    viewBox: "0 0 20.5 20.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6694",
    d: "M270.648 190.4a10.25 10.25 0 1 0 10.25 10.25 10.262 10.262 0 0 0-10.25-10.25zm0 16.015a.641.641 0 1 1 .641-.641.641.641 0 0 1-.641.641zm1.685-4.232a1.751 1.751 0 0 0-1.045 1.54.641.641 0 1 1-1.282 0 3.02 3.02 0 0 1 1.764-2.691 2.548 2.548 0 0 0 1.439-2.3 2.6 2.6 0 0 0-2.562-2.562 2.565 2.565 0 0 0-2.562 2.562.641.641 0 1 1-1.282 0 3.848 3.848 0 0 1 3.844-3.844 3.9 3.9 0 0 1 3.844 3.844 3.82 3.82 0 0 1-2.158 3.456z",
    transform: "translate(-260.398 -190.4)",
    style: {
      fill: "#bebebe"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqs);
export default __webpack_public_path__ + "static/media/faqs.bf976b5cce997dfdf2fcb78293361832.svg";
export { ForwardRef as ReactComponent };